import { ButtonHTMLAttributes, FC } from "react";
import "./Button.scss";

const Button: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ type = "button", className, ...otherProps }) => {
  return <button className={`leisure-landing-button ${className || ""}`} type={type} {...otherProps} />;
};

export default Button;
